module.exports = __webpack_public_path__ + "img/onelinc-logo-v2-horizontal-no-tagline-no-wings-white-vect.5b8e5106.svg";